
const getProductsQuery = `
  query GetProducts($after: String, $query: String, $sortKey: ProductSortKeys!, $reverse: Boolean!) {
    products(first: 20, sortKey: $sortKey, reverse: $reverse, after: $after, query: $query) {
      edges {
        cursor
        node {
          id
          title
          tags
          vendor
          productType
          descriptionHtml
          category {
            id
            name
          }
          images(first: 10) {
            edges {
              node {
                id
                url
                altText
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                price { amount currencyCode }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

const getCartQuery = `
  query GetCart($id: ID!) {
    cart(id: $id) {
      id
      checkoutUrl
      totalQuantity
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            quantity
            merchandise {
              __typename
              ... on ProductVariant {
                id
                title
                quantityAvailable
                price { amount currencyCode }
                image { url }
                product { title }
              }
            }
          }
        }
      }
    }
  }
`;

const cartLinesUpdateMutation = `
      mutation CartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            id
            checkoutUrl
            totalQuantity
            lines(first: 100) {
              edges {
                node {
                  id
                  quantity
                  merchandise {
                    __typename
                    ... on ProductVariant {
                      id
                      title
                      quantityAvailable
                      price { amount currencyCode }
                      image { url }
                      product { title }
                    }
                  }
                }
              }
            }
          }
          userErrors { field message }
        }
      }
    `;

const cartCreateMutation = `
      mutation CartCreate($lines: [CartLineInput!]) {
        cartCreate(input: { lines: $lines }) {
          cart {
            id
            checkoutUrl
          }
          userErrors { field message }
        }
      }
    `;

const cartLinesRemoveMutation = `
      mutation CartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
          cart {
            id
            checkoutUrl
            totalQuantity
            lines(first: 100) {
              edges {
                node {
                  id
                  quantity
                  merchandise {
                    __typename
                    ... on ProductVariant {
                      id
                      title
                      price { amount currencyCode }
                      image { url }
                      product { title }
                    }
                  }
                }
              }
            }
          }
          userErrors { field message }
        }
      }
    `;


const cartLinesAddMutation = `
      mutation CartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            id
            checkoutUrl
          }
          userErrors { field message }
        }
      }
    `;

export {
    getProductsQuery, 
    getCartQuery,
    cartLinesUpdateMutation, 
    cartCreateMutation,
    cartLinesRemoveMutation,
    cartLinesAddMutation,
}